var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepthOverviewMarketplaceAppSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 45,
    viewBox: "0 0 254 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.19 0H2.93651C1.31472 0 0 1.31445 0 2.9359V41.6897C0 43.3112 1.31472 44.6256 2.93651 44.6256H250.19C251.812 44.6256 253.127 43.3112 253.127 41.6897V2.9359C253.127 1.31445 251.812 0 250.19 0Z",
    fill: "#D3C5D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepthOverviewMarketplaceAppSecondary);
export default __webpack_public_path__ + "static/media/depth_overview_marketplace_app_secondary.18f6a64211f30dac8d1dc34c89d9f5fd.svg";
export { ForwardRef as ReactComponent };